import {
  core_apimessages_Money as Money,
} from '@reverbdotcom/commons/src/gql/graphql';
import React from 'react';
import { PayPalScriptProvider, PayPalMessages } from '@paypal/react-paypal-js';
import { PAYPAL_CLIENT_ID, EU_GB_PAYPAL_CLIENT_ID } from '@reverbdotcom/env';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';


interface Props {
  amountTotal: Money;
}

export function ListingPayPalCallout({
  amountTotal,
}: Props) {
  const isUKPayPalPayLaterCalloutEnabled = useExpEnabled(experiments.UK_PAYPAL_PAY_LATER_CALLOUT);

  const price = Number(amountTotal.amount);
  const { currency } = amountTotal;
  const clientId = currency === 'GBP' ? EU_GB_PAYPAL_CLIENT_ID : PAYPAL_CLIENT_ID;
  const options = {
    currency,
    clientId,
    components: 'messages',
  };

  if (currency === 'GBP' && !isUKPayPalPayLaterCalloutEnabled) return null;

  return (
    <PayPalScriptProvider options={options}>
      <PayPalMessages
        style={{ layout: 'text', logo: { type: 'inline' }, text: { size: 14 } }}
        className="listing-paypal-callout"
        amount={price}
      />
    </PayPalScriptProvider>
  );
}
